import React from 'react';
import StatsCard from './StatsCard';
import IconSvg from 'src/components/common/ui/IconSvg';

interface DashboardStatsProps {
  performanceData: {
    allTimeStats: {
      totalSpend: string;
      totalSpendGraphData: number[];
      averageCPL: string;
      averageCPLGraphData: number[];
      averageCPC: string;
      averageCPCGraphData: number[];
    };
    last7DaysStats: {
      totalSpend: string;
      totalSpendGraphData: number[];
    };
  };
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ performanceData }) => {
  if (!performanceData) return null; // todo remove

  const stats = [
    {
      icon: <IconSvg icon="barChart" />,
      title: 'Last 7 days',
      value: performanceData.last7DaysStats.totalSpend || '$0',
      graphData: performanceData.last7DaysStats.totalSpendGraphData,
    },
    {
      icon: <IconSvg icon="trendIcon" />,
      title: 'Average CPL',
      value: performanceData.allTimeStats.averageCPL || '$0',
      graphData: performanceData.allTimeStats.averageCPLGraphData,
    },
    {
      icon: <IconSvg icon="trendIcon" />,
      title: 'Average CPC',
      value: performanceData.allTimeStats.averageCPC || '$0',
      graphData: performanceData.allTimeStats.averageCPCGraphData,
    },
    {
      icon: <IconSvg icon="dollarCycleIcon" />,
      title: 'Total Spend',
      value: performanceData.allTimeStats.totalSpend || '$0',
      graphData: performanceData.allTimeStats.totalSpendGraphData,
    },
  ];

  return (
    <div className="w-full sm:overflow-x-visible overflow-x-auto hide-scrollbar lg:mt-0 mt-4">
      <div className="flex items-center sm:justify-between space-x-4 sm:w-full w-max">
        {stats.map((stat, index) => (
          <StatsCard
            key={index}
            icon={stat.icon}
            title={stat.title}
            value={stat.value}
            graphData={stat.graphData}
          />
        ))}
      </div>
    </div>
  );
};

export default DashboardStats;
